import React from 'react';
import { Link } from 'react-router-dom';
import { Sun, CalendarCheck, MessageSquare } from 'lucide-react';
import { LUNCH_RESET, STUDIO } from './midtownData';

const timeline = [
  { time: '12:00', label: 'Walk in, quick check-in' },
  { time: '12:05', label: 'On the table — neck, shoulders, upper back' },
  { time: '12:35', label: 'Back out the door, loose and clear' },
];

const chips = [
  { id: 'price', text: `$${LUNCH_RESET.price}` },
  { id: 'length', text: `${LUNCH_RESET.minutes} minutes` },
  { id: 'window', text: `${LUNCH_RESET.window} · ${LUNCH_RESET.daysShort}` },
];

const LunchTicket = () => (
  <div className="relative bg-white rounded-[2rem] p-8 shadow-2xl -rotate-1 border-2 border-dashed border-amber-300" data-testid="lunch-reset-ticket">
    <p className="text-xs uppercase tracking-[0.25em] text-amber-700">A sample lunch break</p>
    <ol className="mt-6 space-y-5">
      {timeline.map((t) => (
        <li key={t.time} className="flex items-baseline gap-5">
          <span className="font-serif text-3xl text-gray-900 w-20 shrink-0">{t.time}</span>
          <span className="text-gray-700">{t.label}</span>
        </li>
      ))}
    </ol>
    <p className="mt-8 pt-6 border-t border-dashed border-amber-200 text-sm text-gray-600">
      Lunch slots: <strong className="text-gray-900">{LUNCH_RESET.window}</strong>, {LUNCH_RESET.days}
    </p>
  </div>
);

const MidtownLunchReset = () => (
  <section id="lunch-reset" className="relative bg-amber-50 py-20 overflow-hidden scroll-mt-6" data-testid="midtown-lunch-reset">
    <div className="absolute -bottom-24 right-1/3 w-80 h-80 rounded-full bg-amber-200/50 blur-3xl" aria-hidden="true" />
    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-12 items-center">
      <div className="lg:col-span-7">
        <span className="inline-flex items-center gap-2 bg-amber-400 text-gray-900 text-xs font-semibold tracking-[0.2em] uppercase px-4 py-2 rounded-full" data-testid="lunch-reset-eyebrow">
          <Sun className="w-4 h-4" /> Midtown Lunch Reset
        </span>
        <h2 className="mt-6 text-3xl md:text-5xl font-serif text-gray-900 leading-tight" data-testid="lunch-reset-title">
          30 minutes on the table. Back at your desk by one.
        </h2>
        <p className="mt-6 text-gray-700 leading-relaxed max-w-xl">
          This one's for the state workers around the Capitol and the Sutter crew between shifts. A focused half hour on your neck, shoulders and upper back — where a desk or a long shift sits heaviest — so you walk back out clear-headed, not ready for a nap.
        </p>
        <ul className="mt-8 flex flex-wrap gap-3">
          {chips.map((c) => (
            <li key={c.id} className="bg-white border border-amber-300 text-gray-900 px-4 py-2 rounded-full text-sm" data-testid={`lunch-reset-chip-${c.id}`}>{c.text}</li>
          ))}
        </ul>
        <div className="mt-10 flex flex-col sm:flex-row gap-4">
          <Link to="/book" className="inline-flex items-center justify-center gap-2 bg-gray-900 text-white px-8 py-4 rounded-full hover:bg-amber-600 transition-colors duration-300" data-testid="lunch-reset-book-btn">
            <CalendarCheck className="w-5 h-5" /> Book a Lunch Reset
          </Link>
          <a href={`sms:${STUDIO.phoneE164}`} className="inline-flex items-center justify-center gap-2 border-2 border-gray-900 text-gray-900 px-8 py-4 rounded-full hover:bg-gray-900 hover:text-white transition-colors duration-300" data-testid="lunch-reset-text-btn">
            <MessageSquare className="w-5 h-5" /> Text about today's openings
          </a>
        </div>
        <p className="mt-4 text-xs text-gray-500">When booking, pick the 30-minute massage in a slot between 11 and 2.</p>
      </div>
      <div className="lg:col-span-5">
        <LunchTicket />
      </div>
    </div>
  </section>
);

export default MidtownLunchReset;
